import { jsx } from "react/jsx-runtime";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { validateTidalLicense } from "../../base/index.js";
function ZoomOut(props) {
  return /* @__PURE__ */ jsx(
    ZoomOutIcon,
    {
      "data-testid": "ZoomOut",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ZoomOut",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
ZoomOut.tidalIconMeta = {
  categories: "map,location,time",
  name: "ZoomOut"
};
validateTidalLicense();
export {
  ZoomOut
};
//# sourceMappingURL=ZoomOut.js.map
